import { Pipe, PipeTransform } from '@angular/core';
import { checkString } from '@lockton-apps/shared/util/helpers';
import {
  filter,
  get,
  isObject,
  isString,
  pick,
  toString,
  values,
  join,
} from 'lodash';

// #TODO - optimise this api
@Pipe({
  name: 'filterWith',
  standalone: true,
})
export class FilterWithPipe implements PipeTransform {
  transform<T>(entities: T[] | null, filterString: string, path?: string): T[];
  transform<T>(
    entities: T[] | null,
    filterString: string,
    paths?: string[]
  ): T[];

  transform<T>(
    entities: T[] | null,
    filterString: string,
    path: string | string[] = ''
  ): T[] {
    if (!entities) {
      return [];
    }
    return filter(entities, (entity) => {
      let str = '';

      if (!isObject(entity)) {
        str = toString(entity);
      } else {
        str = isString(path)
          ? get(entity, path)
          : join(values(pick(entity, path)));
      }

      return checkString(str, filterString);
    });
  }
}
